var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiceSix = function SvgIconDiceSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 7.875a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9 17.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 16.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 6A3.25 3.25 0 0 1 6 2.75h12A3.25 3.25 0 0 1 21.25 6v12A3.25 3.25 0 0 1 18 21.25H6A3.25 3.25 0 0 1 2.75 18zM6 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconDiceSix;